// extracted by mini-css-extract-plugin
export default {"revoked":"RevokedKeys_revoked__CcmpO"};